import Cookies from 'js-cookie'
const TokenKey = 'zonghe-token'
export const TokenColorKey = 'zonghe-color-token'
export const TokenLangKey = 'zonghe-lang-token'
export const TokenAccount = 'zonghe-account'

export function getToken () {
  try {
    let result = Cookies.get(TokenKey) ? JSON.parse(Cookies.get(TokenKey)) : ''
    if (result && result.length > 0) {
      return result
    } else {
      try {
        result = localStorage.getItem(TokenKey) ? JSON.parse(localStorage.getItem(TokenKey)) : ''
      } catch (error) {
        result = ''
      }
    }
    return result
  } catch (error) {
    return ''
  }
}

export function setToken (token) {
  localStorage.setItem(TokenKey, JSON.stringify(token))
  return Cookies.set(TokenKey, JSON.stringify(token))
}

export function removeToken () {
  localStorage.removeItem(TokenKey)
  return Cookies.remove(TokenKey)
}

export function getTokenbyName (name) {
  try {
    let result = Cookies.get(name) ? JSON.parse(Cookies.get(name)) : ''
    if (result && result.length > 0) {
      return result
    } else {
      try {
        result = localStorage.getItem(name) ? JSON.parse(localStorage.getItem(name)) : ''
      } catch (error) {
        result = ''
      }
    }
    return result
  } catch (error) {
    return ''
  }
}

export function setTokenbyName (name,token) {
  localStorage.setItem(name, JSON.stringify(token))
  return Cookies.set(name, JSON.stringify(token))
}

export function removeTokenbyName (name) {
  localStorage.removeItem(name)
  return Cookies.remove(name)
}
